"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.coordinates = coordinates;

/**
 * @module ol/geom/flat/reverse
 */

/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 */
function coordinates(flatCoordinates, offset, end, stride) {
  while (offset < end - stride) {
    for (var i = 0; i < stride; ++i) {
      var tmp = flatCoordinates[offset + i];
      flatCoordinates[offset + i] = flatCoordinates[end - stride + i];
      flatCoordinates[end - stride + i] = tmp;
    }

    offset += stride;
    end -= stride;
  }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBSUE7Ozs7OztBQU1NLFNBQVVBLFdBQVYsQ0FBc0JDLGVBQXRCLEVBQXVDQyxNQUF2QyxFQUErQ0MsR0FBL0MsRUFBb0RDLE1BQXBELEVBQTBEO0VBQzlELE9BQU9GLE1BQU0sR0FBR0MsR0FBRyxHQUFHQyxNQUF0QixFQUE4QjtJQUM1QixLQUFLLElBQUlDLENBQUMsR0FBRyxDQUFiLEVBQWdCQSxDQUFDLEdBQUdELE1BQXBCLEVBQTRCLEVBQUVDLENBQTlCLEVBQWlDO01BQy9CLElBQU1DLEdBQUcsR0FBR0wsZUFBZSxDQUFDQyxNQUFNLEdBQUdHLENBQVYsQ0FBM0I7TUFDQUosZUFBZSxDQUFDQyxNQUFNLEdBQUdHLENBQVYsQ0FBZixHQUE4QkosZUFBZSxDQUFDRSxHQUFHLEdBQUdDLE1BQU4sR0FBZUMsQ0FBaEIsQ0FBN0M7TUFDQUosZUFBZSxDQUFDRSxHQUFHLEdBQUdDLE1BQU4sR0FBZUMsQ0FBaEIsQ0FBZixHQUFvQ0MsR0FBcEM7SUFDRDs7SUFDREosTUFBTSxJQUFJRSxNQUFWO0lBQ0FELEdBQUcsSUFBSUMsTUFBUDtFQUNEO0FBQ0YiLCJuYW1lcyI6WyJjb29yZGluYXRlcyIsImZsYXRDb29yZGluYXRlcyIsIm9mZnNldCIsImVuZCIsInN0cmlkZSIsImkiLCJ0bXAiXSwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2dlb20vZmxhdC9yZXZlcnNlLmpzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF19